import React from 'react';
import { SmoothScroll } from './components/common/SmoothScroll';
import { CustomCursor } from './components/common/CustomCursor';
import { CraftInspector } from './components/common/CraftInspector';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { CSSBiomePoster } from './components/canvas/CSSBiomePoster';
import { LivingBiomeCanvas3D } from './components/canvas/LivingBiomeCanvas3D';

import { HeaderNav } from './components/sections/HeaderNav';
import { HeroSection } from './components/sections/HeroSection';
import { EcologicalManifesto } from './components/sections/EcologicalManifesto';
import { PlanetaryPillars } from './components/sections/PlanetaryPillars';
import { BentoBiosphereOS } from './components/sections/BentoBiosphereOS';
import { BiosphereSimulator } from './components/sections/BiosphereSimulator';
import { ImpactMatrix } from './components/sections/ImpactMatrix';
import { ScientificVoices } from './components/sections/ScientificVoices';
import { GrandFinale } from './components/sections/GrandFinale';
import { MinimalFooter } from './components/sections/MinimalFooter';
import { useAutoUpdate } from './hooks/useAutoUpdate';

export const App: React.FC = () => {
  useAutoUpdate();

  return (
    <SmoothScroll>
      {/* Precision Ink Cursor */}
      <CustomCursor />

      {/* Procedural 3D Living Biome Surface Backdrop with Topographic Fallback */}
      <ErrorBoundary fallback={<CSSBiomePoster />}>
        <LivingBiomeCanvas3D />
      </ErrorBoundary>

      {/* Tactile Paper Texture Overlay (Desktop only) */}
      <div
        className="hidden md:block paper-grain-overlay pointer-events-none fixed inset-0 z-40 opacity-[0.025]"
        aria-hidden="true"
      />

      {/* Swiss Architectural Top Bar Navigation */}
      <HeaderNav />

      {/* Main Exhibition Sequence */}
      <main className="relative z-10 w-full overflow-x-hidden bg-transparent">
        <HeroSection />
        <EcologicalManifesto />
        <PlanetaryPillars />
        <BentoBiosphereOS />
        <BiosphereSimulator />
        <ImpactMatrix />
        <ScientificVoices />
        <GrandFinale />
      </main>

      {/* Architectural Minimal Footer with Required Disclaimer & Creator Links */}
      <MinimalFooter />

      {/* Live Craft Telemetry HUD */}
      <CraftInspector />
    </SmoothScroll>
  );
};

export default App;
